<script setup lang="ts">
import type { ComponentEmergencySlotProps } from "./ComponentEmergencySlot.props"
import { emergencySlotIconMapping } from "./ComponentEmergencySlot.mapping"

const props = defineProps<ComponentEmergencySlotProps>()

const darkenHexColor = (hex: string) => {
  // Remove the "#" if present
  hex = hex.replace(/^#/, "")

  // Convert 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("")
  }

  // Darken each color component
  const darkened = [0, 1, 2].map((i) => {
    const part = parseInt(hex.slice(i * 2, i * 2 + 2), 16)
    const amount = 30
    const newPart = Math.max(0, part - amount)
    return newPart.toString(16).padStart(2, "0")
  })

  return `#${darkened.join("")}`
}

const mappedIcon = computed(() =>
  props.icon ? emergencySlotIconMapping[props.icon] : ""
)

const isActive = computed(() => !!props.message)
</script>

<template>
  <div
    id="emergencyContainer"
    v-if="isActive"
    class="
      beaver
      flex
      w-full
      flex-col
      gap-1
      break-normal
      rounded-lg
      border-2
      px-4
      py-5
    "
    :style="{
      backgroundColor,
      borderColor: backgroundColor && darkenHexColor(backgroundColor),
      color: textColor
    }"
  >
    <div v-if="title" class="beaver-bold text-center">{{ title }}</div>
    <div class="flex items-center gap-4">
      <UtilsIcon
        v-if="mappedIcon"
        fetch-priority="high"
        :preload="true"
        :name="mappedIcon"
        :class="`h-12 w-12`"
      />
      <UtilsMarkdown v-if="message" :content="message" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
#emergencyContainer {
  :deep(a:not([class])) {
    @apply text-green-main cursor-pointer underline;
  }
}
</style>
